<template>
  <v-container fluid>
    <v-card>
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Pedidos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          fab
          small
          color="primary lighten-4"
          class="mr-2"
          @click="abrirDialogoFiltro"
        >
          <v-badge
            bordered
            color="warning"
            content="!"
            :value="filtro_aplicado"
            overlap
          >
            <v-icon>mdi-filter</v-icon>
          </v-badge>
        </v-btn>

        <v-btn
          fab
          small
          class="mr-2"
          color="primary lighten-4"
          @click="$refs.dialogoImpressaoListagem.abrir()"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn fab small color="primary lighten-4" @click="tooglePesquisa">
          <v-icon>search</v-icon>
        </v-btn>
        <v-btn
          depressed
          color="primary lighten-4"
          @click="$router.push('/pedidos/adicionar')"
          v-if="user.tipo == 'fornecedor' && rodada && rodada.permitir_pedidos"
          class="hidden-xs-only lighten-4 ml-2"
          >Novo Pedido</v-btn
        >
        <v-btn
          fab
          small
          color="primary lighten-4 ml-2"
          @click="$router.push('/pedidos/adicionar')"
          v-if="user.tipo == 'fornecedor' && rodada && rodada.permitir_pedidos"
          class="hidden-sm-and-up"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card>
        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" class="pa-1">
            <v-col cols="12" class="pa-2">
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                background-color="grey lighten-2"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-container fluid class="pa-3 py-0">
          <v-row>
            <v-col
              class="red lighten-5 red--text"
              v-show="rodada.id"
              style="display: flex"
            >
              <span>{{ rodada.nome }}</span>
              <v-spacer />
              <v-chip
                v-if="rodada && !rodada.permitir_pedidos"
                small
                color="red"
                text-color="white"
                style="min-width: 112px"
                >Apenas consulta</v-chip
              >
            </v-col>
          </v-row>

          <!-- <v-row dense class="justify-end pb-2">
            <v-col class="px-2" cols="12" sm="2" v-if="user.tipo == 'representante'">
              <v-text-field
                :value="valorEntregues | valorBR"
                readonly
                hide-details
                label="Entregues"
                type="text"
              >
                <template v-slot:append>
                  <v-chip
                    label
                    color="green"
                    text-color="white"
                    class="mb-1 px-3"
                    style="height: 24px"
                  >
                    <b>{{ quantidadePedidosEntregues }}</b>
                  </v-chip>
                </template>
              </v-text-field>
            </v-col>

            <v-col class="px-2" cols="12" sm="2" v-if="user.tipo == 'representante'">
              <v-text-field
                :value="valorPendentes | valorBR"
                readonly
                hide-details
                label="Pendentes"
                type="text"
              >
                <template v-slot:append>
                  <v-chip
                    label
                    color="red"
                    text-color="white"
                    class="mb-1 px-3"
                    style="height: 24px"
                  >
                    <b>{{ quantidadePedidosPendentes }}</b>
                  </v-chip>
                </template>
              </v-text-field>
            </v-col>

            <v-col class="px-2" cols="12" sm="2">
              <v-text-field
                :value="valorGeral | valorBR"
                readonly
                hide-details
                label="Total"
                type="text"
              >
                <template v-slot:append>
                  <v-chip
                    label
                    color="blue"
                    text-color="white"
                    class="mb-1 px-3"
                    style="height: 24px"
                  >
                    <b>{{ quantidadePedidos }}</b>
                  </v-chip>
                </template>
              </v-text-field>
            </v-col>
          </v-row> -->

          <v-row dense class="justify-end pb-2">
            <v-col
              class="px-2"
              cols="12"
              sm="2"
              v-if="user.tipo == 'representante'"
            >
              <v-text-field
                :value="valorPendentes | valorBR"
                readonly
                hide-details
                label="Pendentes"
                type="text"
              >
                <template v-slot:append>
                  <v-chip
                    label
                    color="red"
                    text-color="white"
                    class="mb-1 px-3"
                    style="height: 24px"
                  >
                    <b>{{ quantidadePedidosPendentes }}</b>
                  </v-chip>
                </template>
              </v-text-field>
            </v-col>

            <v-col
              class="px-2"
              cols="12"
              sm="2"
              v-if="user.tipo == 'representante'"
            >
              <v-text-field
                :value="valorEntregues | valorBR"
                readonly
                hide-details
                label="Entregues"
                type="text"
              >
                <template v-slot:append>
                  <v-chip
                    label
                    color="green"
                    text-color="white"
                    class="mb-1 px-3"
                    style="height: 24px"
                  >
                    <b>{{ quantidadePedidosEntregues }}</b>
                  </v-chip>
                </template>
              </v-text-field>
            </v-col>

            <v-col
              class="px-2"
              cols="12"
              sm="2"
              v-if="user.tipo == 'representante'"
            >
              <v-text-field
                :value="valorEnviados | valorBR"
                readonly
                hide-details
                label="Enviados"
                type="text"
              >
                <template v-slot:append>
                  <v-chip
                    label
                    color="blue"
                    text-color="white"
                    class="mb-1 px-3"
                    style="height: 24px"
                  >
                    <b>{{ quantidadePedidosEnviados }}</b>
                  </v-chip>
                </template>
              </v-text-field>
            </v-col>

            <v-col class="px-2" cols="12" sm="2">
              <v-chip
                label
                color="orange"
                class="mx-4 mt-3 blinking"
                v-if="sincronizando && user.tipo == 'fornecedor'"
              >
                Sincronizando...
              </v-chip>
            </v-col>
            <v-col class="px-2" cols="12" sm="2">
              <v-text-field
                :value="valorGeral | valorBR"
                readonly
                hide-details
                label="Total"
                type="text"
              >
                <template v-slot:append>
                  <v-chip
                    label
                    color="primary"
                    text-color="white"
                    class="mb-1 px-3"
                    style="height: 24px"
                  >
                    <b>{{ quantidadePedidos }}</b>
                  </v-chip>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>

        <v-divider />
        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="pedidos"
          :loading="loading"
          no-data-text="Sem registros"
          no-results-text="Sem registros"
          loading-text="Carregando dados..."
          :items-per-page="30"
          :footer-props="{
            itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
            itemsPerPageText: '',
          }"
        >
          <template
            v-slot:item.status="{ item }"
            v-if="user.tipo == 'representante' || user.tipo == 'cliente'"
          >
            <v-chip
              label
              color="gray"
              text-color="black"
              small
              v-if="item.status == 0"
            >
              <span style="cursor: pointer;">Pendente</span>
            </v-chip>

            <v-chip label color="primary" dark small v-if="item.status == 1">
              <span style="cursor: pointer;">Revisado</span>
            </v-chip>

            <v-chip
              label
              color="green"
              text-color="white"
              small
              pa-1
              v-if="item.status == 3"
            >
              <span style="cursor: pointer;">Entregue</span>
            </v-chip>

            <v-chip
              label
              color="blue"
              text-color="white"
              small
              pa-1
              v-if="item.status == 4"
            >
              <span style="cursor: pointer;">Enviado</span>
            </v-chip>
          </template>

          <template v-slot:item.id="{ item }">
            <v-chip
              label
              :class="sincronizando && item.offline ? 'py-1 blinking' : 'py-1'"
              :color="item.offline ? 'orange' : undefined"
              style="width: 80px; justify-content: center"
              >{{ item.id || "NOVO" }}</v-chip
            >
          </template>

          <template v-slot:item.razao_social="{ item }">
            {{ item.razao_social }}<br />
            <span class="caption font-weight-light">{{ item.cnpj }}</span>
          </template>

          <template v-slot:item.nome_fantasia="{ item }">
            {{ item.nome_fantasia }}<br />
            <span
              v-if="item.nome_fantasia != item.cliente_nome"
              class="caption font-weight-light"
              >{{ item.cliente_nome }}</span
            >
          </template>

          <template v-slot:item.valor_liquido="{ item }">{{
            item.valor_liquido | valorBR
          }}</template>

          <template v-slot:item.acoes="{ item }">
            <v-tooltip v-if="item.status == 5" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  label
                  color="red"
                  text-color="white"
                  small
                  class="pa-1"
                  v-bind="attrs"
                  v-on="on"
                  >CAN</v-chip
                >
              </template>
              <span>Cancelado</span>
            </v-tooltip>

            <v-menu v-else bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  v-if="user.tipo == 'cliente'"
                  @click="detalharPedidoCliente(item.pedido_cliente)"
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">mdi-text-box-check-outline</v-icon
                    >Detalhar
                  </v-list-item-title>
                </v-list-item>

                <v-list-item @click="abrirDialogoImpressao(item)">
                  <v-list-item-title>
                    <v-icon class="mr-4">print</v-icon>Imprimir
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="
                    $router.push(
                      'pedidos/' +
                        (item.id || item.uuid) +
                        '/editar' +
                        (item.id ? '?uuid=' + item.uuid : '')
                    )
                  "
                  v-if="user.tipo == 'fornecedor'"
                  :disabled="
                    $store.state.rodadaSetada && !rodada.permitir_pedidos
                  "
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">edit</v-icon>Editar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="
                    $router.push(
                      'pedidos/' +
                        (item.id || item.uuid) +
                        '/editar' +
                        (item.id ? '?uuid=' + item.uuid : '')
                    )
                  "
                  v-if="user.tipo == 'representante'"
                  :disabled="rodada && !rodada.permitir_pedidos"
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">edit</v-icon>Revisar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="abrirDialogoCopia(item)"
                  v-if="user.tipo == 'fornecedor'"
                  :disabled="rodada && !rodada.permitir_pedidos"
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">file_copy</v-icon>Copiar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="abrirDialogoCancelamento(item)"
                  v-if="
                    item.status != 5 &&
                      ((user.tipo == 'fornecedor' && item.status != 0) ||
                        (user.tipo == 'cliente' && item.status == 0) ||
                        (user.tipo == 'representante' && item.status == 0))
                  "
                  :disabled="
                    $store.state.rodadaSetada && !rodada.permitir_pedidos
                  "
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">close</v-icon>Cancelar
                  </v-list-item-title>
                </v-list-item>

                <v-list-item
                  @click="abrirDialogoEntrega(item)"
                  v-if="user.tipo == 'representante' && item.status == 1"
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">local_shipping</v-icon>Informar Entrega
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>

      <as-dialogo
        ref="dialogoCancelamento"
        title="Cancelar Pedido"
        max-width="440px"
        hideCloseButton
      >
        <v-label>Deseja confirmar o cancelamento desse pedido?</v-label>
        <div class="d-flex pt-8" style="justify-content: flex-end">
          <v-btn
            depressed
            class="mr-4"
            @click="$refs.dialogoCancelamento.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="error"
            @click="cancelarPedido"
            :disabled="cancelando"
            :loading="cancelando"
            >Confirmar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoCopia"
        title="Copiar Pedido"
        max-width="440px"
        hideCloseButton
      >
        <v-label>Deseja fazer a cópia completa desse pedido?</v-label>
        <div class="d-flex pt-8" style="justify-content: flex-end">
          <v-btn depressed class="mr-4" @click="$refs.dialogoCopia.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="copiarPedido"
            :disabled="copiando"
            :loading="copiando"
            >Confirmar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoImpressaoListagem"
        title="Imprimir"
        max-width="440px"
        hideCloseButton
      >
        <v-label>Deseja imprimir a listagem de vendas?</v-label>
        <div class="d-flex pt-8" style="justify-content: flex-end">
          <v-btn
            depressed
            class="mr-4"
            @click="$refs.dialogoImpressaoListagem.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="imprimirListagem"
            :disabled="imprimindo"
            :loading="imprimindo"
            >Imprimir</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoImpressao"
        title="Imprimir"
        max-width="440px"
        hideCloseButton
      >
        <v-label>Deseja imprimir este pedido?</v-label>
        <div class="d-flex pt-8" style="justify-content: flex-end">
          <v-btn
            depressed
            class="mr-4"
            @click="$refs.dialogoImpressao.fechar()"
            :disabled="imprimindo"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="imprimirPedido"
            :disabled="imprimindo"
            :loading="imprimindo"
            >Imprimir</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoFiltro"
        title="Filtro de Pedidos"
        max-width="800px"
        hideCloseButton
      >
        <v-form ref="form_filtro" lazy-validation v-show="!load_filtro">
          <v-row v-if="user.tipo == 'fornecedor'">
            <v-col cols="12" sm="6" class="pt-0">
              <v-autocomplete
                v-model="filtro.cliente_loja_id"
                ref="cliente_id"
                :items="clientes"
                @change="setCliente"
                label="Cliente"
                placeholder="Selecione um cliente"
                hide-details
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="data.item.text"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-html="data.item.cnpj"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" class="pt-0">
              <v-autocomplete
                v-model="filtro.representante_id"
                ref="representante_id"
                :items="representantes"
                label="Representante"
                placeholder="Selecione um representante"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row v-if="user.tipo == 'representante'">
            <v-col cols="12" sm="4" class="pt-0">
              <v-autocomplete
                v-model="filtro.cliente_id"
                ref="cliente_id"
                :items="clientes"
                label="Cliente"
                @change="carregarLojas"
                placeholder="Selecione um cliente"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="4" class="pt-0">
              <v-autocomplete
                v-model="filtro.cliente_loja_id"
                ref="cliente_loja_id"
                :items="lojas"
                label="Loja"
                :loading="carregando_lojas"
                placeholder="Selecione uma loja"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="4" class="pt-0">
              <v-autocomplete
                v-model="filtro.fornecedor_id"
                ref="fornecedor_id"
                :items="fornecedores"
                label="Fornecedor"
                placeholder="Selecione um fornecedor"
                hide-details
                item-value="id"
                item-text="nome_fantasia"
              />
            </v-col>
          </v-row>
          <v-row v-if="user.tipo == 'administrador'">
            <v-col cols="12" class="pt-0">
              <v-autocomplete
                v-model="filtro.cliente_id"
                ref="cliente_id"
                :items="clientes"
                label="Cliente"
                placeholder="Selecione um cliente"
                hide-details
                autocomplete="off"
                role="presentation"
              />
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-autocomplete
                v-model="filtro.fornecedor_id"
                ref="fornecedor_id"
                :items="fornecedores"
                label="Fornecedor"
                placeholder="Selecione um fornecedor"
                hide-details
                autocomplete="off"
                role="presentation"
              />
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-autocomplete
                v-model="filtro.representante_id"
                ref="representante_id"
                :items="representantes"
                label="Representante"
                placeholder="Selecione um representante"
                hide-details
                autocomplete="off"
                role="presentation"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="3" class="pt-0">
              <v-text-field
                label="Número do Pedido"
                ref="pedido"
                v-model="filtro.pedido"
                placeholder="Digite aqui"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3" class="pt-0">
              <v-select
                :items="tipos_data"
                v-model="filtro.data_tipo"
                label="Data"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="6" sm="3" class="pt-0">
              <as-date-picker-menu
                label="Data Inicial"
                ref="data_inicial"
                v-model="filtro.data_inicial"
                :disabled="filtro.data_tipo == 'Nenhuma'"
                hideDetails
              ></as-date-picker-menu>
            </v-col>
            <v-col cols="6" sm="3" class="pt-0">
              <as-date-picker-menu
                label="Data Final"
                ref="data_final"
                v-model="filtro.data_final"
                :disabled="filtro.data_tipo == 'Nenhuma'"
                hideDetails
              ></as-date-picker-menu>
            </v-col>
            <v-col cols="12" sm="6" class="pt-0">
              <v-select
                :items="statusLista"
                label="Status"
                v-model="filtro.status"
                hide-details
              ></v-select>
            </v-col>
          </v-row>
        </v-form>

        <v-row v-show="load_filtro" class="justify-center align-center my-5">
          <v-progress-circular
            indeterminate
            size="50"
            width="3"
            color="primary"
          ></v-progress-circular>
        </v-row>
        <div class="d-flex pt-8" style="justify-content: flex-end">
          <v-btn
            depressed
            color="error"
            class="mr-4 hidden-xs-only"
            v-if="filtro_aplicado"
            @click="cancelarFiltro"
            >Limpar Filtro</v-btn
          >

          <v-btn
            class="mr-2 hidden-sm-and-up"
            color="accent"
            v-if="filtro_aplicado"
            @click="cancelarFiltro"
          >
            <v-icon>mdi-filter-variant-remove</v-icon>
          </v-btn>

          <v-btn depressed class="mr-4" @click="$refs.dialogoFiltro.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="filtrar"
            :loading="filtrando"
            :disabled="filtrando || load_filtro"
            >Filtrar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoEntrega"
        title="Entregar Pedido"
        max-width="440px"
        hideCloseButton
        hideDivider
      >
        <v-label>Deseja confirmar a entrega desse pedido?</v-label>
        <div class="d-flex pt-4" style="justify-content: flex-end">
          <v-btn depressed class="mr-2" @click="$refs.dialogoEntrega.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="entregarPedido"
            :disabled="entregando"
            :loading="entregando"
            >Confirmar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoDesfazerEntrega"
        title="Desfazer Entrega de Pedido"
        max-width="440px"
        hideCloseButton
      >
        <v-label>Deseja desfazer a entrega desse pedido?</v-label>
        <div class="d-flex pt-4" style="justify-content: flex-end">
          <v-btn
            depressed
            class="mr-2"
            @click="$refs.dialogoDesfazerEntrega.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="desfazerEntregaPedido"
            :disabled="entregando"
            :loading="entregando"
            >Confirmar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoDetalhePedidoCliente"
        title="Detalhamento de Pedido"
        max-width="960px"
        :modal="false"
      >
        <PedidosClientesDetalhes :pedido_cliente_id="pedido_cliente.id" />

        <div slot="botoes" class="pa-2">
          <v-btn
            depressed
            color="primary"
            @click="fechardialogoDetalhePedidoCliente"
            >Fechar</v-btn
          >
        </div>
      </as-dialogo>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import PedidosClientesDetalhes from "./PedidosClientesDetalhes.vue";
import ServicePedidos from "@/services/pedidos.js";
import ServiceImpressoes from "@/services/impressoes.js";
import ServiceRelatorios from "@/services/relatorios.js";

// import config from "@/config";

// import { createImpressaoPedido } from "./impressoes/impressao_pedido.js";

export default {
  name: "PedidosLista",
  components: {
    PedidosClientesDetalhes,
  },
  data() {
    return {
      pesquisa: "",
      exibirPesquisa: false,
      loading: false,
      entregando: false,
      carregando_lojas: false,
      user: {},
      headers: [],
      produtos: [],
      rodada: {},
      pedido: {},
      cancelando: false,
      copiando: false,
      clientes: [],
      lojas: [],
      representantes: [],
      fornecedores: [],
      filtrando: false,
      load_filtro: false,
      tipos_data: ["Nenhuma", "Cadastro", "Entrega"],
      filtro_aplicado: false,
      pedido_cliente: {
        id: 0,
      },
      filtro: {
        cliente_id: "",
        cliente_loja_id: "",
        fornecedor_id: "",
        representante_id: "",
        pedido: "",
        data_tipo: "Nenhuma",
        data_inicial: new Date().toJSON().slice(0, 10),
        data_final: new Date().toJSON().slice(0, 10),
        status: "Todos",
      },
      statusLista: ["Todos", "Abertos", "Enviados"],
      imprimindo: false,
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.rodada = JSON.parse(localStorage.getItem("rodada")) || [];

    if (this.user.tipo == "fornecedor") {
      this.headers = [
        { text: "Número", value: "id", width: "5%", align: "left" },
        { text: "Razão Social", value: "razao_social", width: "30%" },
        { text: "Nome Fantasia", value: "nome_fantasia", width: "30%" },
        { text: "Representante", value: "representante_nome", width: "20%" },
        { text: "Valor", value: "valor_liquido", width: "10%", align: "right" },
        {
          text: "",
          value: "acoes",
          width: "5%",
          sortable: false,
          align: "right",
        },
      ];
    } else if (this.user.tipo == "administrador") {
      this.headers = [
        { text: "Número", value: "id", width: "5%", align: "left" },
        { text: "Cliente", value: "cliente_nome", width: "40%" },
        { text: "Fornecedor", value: "fornecedor_nome", width: "40%" },
        { text: "Valor", value: "valor_liquido", width: "10%", align: "right" },
        {
          text: "",
          value: "acoes",
          width: "5%",
          sortable: false,
          align: "right",
        },
      ];
    } else if (this.user.tipo == "representante") {
      this.headers = [
        { text: "Número", value: "id", width: "5%", align: "left" },
        { text: "Cliente", value: "cliente_nome", width: "35%" },
        { text: "Fornecedor", value: "fornecedor_nome", width: "35%" },
        { text: "Status", value: "status", width: "10%", align: "left" },
        { text: "Valor", value: "valor_liquido", width: "10%", align: "right" },
        {
          text: "",
          value: "acoes",
          width: "5%",
          sortable: false,
          align: "right",
        },
      ];
    } else if (this.user.tipo == "cliente") {
      this.headers = [
        { text: "Número", value: "id", width: "5%", align: "left" },
        { text: "Loja", value: "nome_fantasia", width: "30%" },
        { text: "CNPJ", value: "cnpj", width: "20%" },
        { text: "Fornecedor", value: "fornecedor_nome", width: "20%" },
        { text: "Status", value: "status", width: "10%", align: "center" },
        { text: "Valor", value: "valor_liquido", width: "10%", align: "right" },
        {
          text: "",
          value: "acoes",
          width: "5%",
          sortable: false,
          align: "right",
        },
      ];
    }

    this.listar();
  },
  methods: {
    async listar() {
      try {
        this.loading = true;
        let pedidos_response = "";
        if (this.rodada) {
          pedidos_response = await ServicePedidos.listar(this.rodada.id);
        } else {
          pedidos_response = await ServicePedidos.listar(0);
        }
        this.$store.commit("setPedidos", pedidos_response.data.pedidos);
        this.$store.dispatch("loadPedidosFromCache");
      } catch (error) {
        this.$eventbus.erro("Erro ao listar pedidos", error);
      } finally {
        this.loading = false;
      }
    },
    abrirDialogoCancelamento(pedido) {
      this.pedido = pedido;
      this.$refs.dialogoCancelamento.abrir();
    },
    async cancelarPedido() {
      try {
        this.cancelando = true;
        if (this.user.tipo == "cliente" || this.user.tipo == "representante") {
          await ServicePedidos.cancelarPedidoCliente(this.pedido.id);
        } else {
          await ServicePedidos.cancelarPedido(this.pedido.id);
        }
        this.pedido.status = 5;
        this.$eventbus.notificar("Pedido cancelado com sucesso");
      } catch (error) {
        this.$eventbus.erro("Erro ao cancelar o pedido");
      } finally {
        this.$refs.dialogoCancelamento.fechar();
        this.cancelando = false;
        this.pedido = {};
      }
    },
    abrirDialogoCopia(pedido) {
      this.pedido = this.clone(pedido);
      this.$refs.dialogoCopia.abrir();
    },
    copiarPedido() {
      this.$router.push(
        "/pedidos/" +
          (this.pedido.id || this.pedido.uuid) +
          "/copiar" +
          (this.pedido.id ? "?uuid=" + this.pedido.uuid : "")
      );
    },
    async imprimirListagem() {
      try {
        this.imprimindo = true;
        let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
          ? "remota"
          : "local";
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceImpressoes.listarPedidos({
          ...this.filtro,
          impressao,
          rodada_id: this.rodada && this.rodada.id,
        });
        if (impressao == "local") {
          this.$store.commit("setPdfUrl", pdf);
        } else {
          this.$eventbus.notificar(
            "Impressão encaminhada para a Ilha de Impressão com sucesso"
          );
        }
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir listagem de pedidos");
      } finally {
        this.imprimindo = false;
        this.$refs.dialogoImpressaoListagem.fechar();
      }
    },
    async abrirDialogoFiltro() {
      try {
        this.load_filtro = true;
        this.$refs.dialogoFiltro.abrir();

        let rodada_id = 0;
        if (this.rodada) {
          rodada_id = this.rodada.id ? this.rodada.id : "0";
        }

        if (this.user.tipo != "cliente") {
          if (this.clientes.length == 0) {
            let clientes = await ServiceRelatorios.getClientes({
              rodada_id: this.rodada && this.rodada.id,
            });
            this.clientes = clientes.data.clientes;
          }
        }

        if (this.user.tipo == "fornecedor") {
          if (this.representantes.length == 0) {
            let representantes = await ServicePedidos.getRepresentantes(
              rodada_id
            );
            this.representantes = representantes.data.representantes;
          }
        } else if (this.user.tipo == "representante") {
          if (this.fornecedores.length == 0) {
            let fornecedores = await ServicePedidos.getFornecedores(rodada_id);
            this.fornecedores = fornecedores.data.fornecedores;
          }
        } else if (this.user.tipo == "administrador") {
          if (this.representantes.length == 0) {
            let representantes = await ServicePedidos.getRepresentantes(
              rodada_id
            );
            this.representantes = representantes.data.representantes;
          }

          if (this.fornecedores.length == 0) {
            let fornecedores = await ServicePedidos.getFornecedores(rodada_id);
            this.fornecedores = fornecedores.data.fornecedores;
          }
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar filtro");
      } finally {
        this.load_filtro = false;
      }
    },
    async carregarLojas() {
      try {
        this.carregando_lojas = true;
        let lojas = await ServicePedidos.getLojas(this.filtro.cliente_id);
        this.lojas = lojas.data.lojas;
      } catch (error) {
        this.$eventbus.erro("Erro ao carregar lojas");
      } finally {
        this.carregando_lojas = false;
      }
    },
    async filtrar() {
      try {
        this.filtrando = true;
        let response = await ServicePedidos.filtrar({
          ...this.filtro,
          rodada_id: this.rodada && this.rodada.id,
        });

        this.$store.commit("setPedidos", response.data.pedidos);

        this.filtro_aplicado = true;
      } catch (error) {
        this.$eventbus.erro("Erro ao aplicar filtro");
      } finally {
        this.filtrando = false;
        this.$refs.dialogoFiltro.fechar();
      }
    },
    cancelarFiltro() {
      this.filtro = {
        cliente_id: "",
        cliente_loja_id: "",
        fornecedor_id: "",
        representante_id: "",
        pedido: "",
        data_tipo: "Nenhuma",
        status: "Todos",
        data_inicial: new Date().toJSON().slice(0, 10),
        data_final: new Date().toJSON().slice(0, 10),
      };
      this.listar();
      this.filtro_aplicado = false;
      this.$refs.dialogoFiltro.fechar();
    },
    abrirDialogoImpressao(pedido) {
      this.pedido = pedido;
      this.$refs.dialogoImpressao.abrir();
    },
    async imprimirPedido() {
      try {
        this.imprimindo = true;
        let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
          ? "remota"
          : "local";
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceImpressoes.imprimirPedido({
          impressao,
          pedido_id: this.pedido.id,
          rodada_id: this.$store.state.rodada.id,
        });

        if (impressao == "local") {
          this.$store.commit("setPdfUrl", pdf);
        } else {
          this.$eventbus.notificar(
            "Impressão encaminhada para a Ilha de Impressão"
          );
        }

        // Novo sistema de impressão em PDF

        /* let pedido_response = await ServicePedidos.imprimir(this.pedido.id);

        let impressao = createImpressaoPedido(
          pedido_response.data.pedido,
          this.user
        );
        impressao.processar();
        impressao.imprimirPDF(); */
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir este pedido");
      } finally {
        this.imprimindo = false;
        this.$refs.dialogoImpressao.fechar();
      }
    },
    abrirDialogoEntrega(pedido) {
      this.pedido = pedido;
      this.$refs.dialogoEntrega.abrir();
    },
    async entregarPedido() {
      try {
        this.entregando = true;
        await ServicePedidos.entregarPedido(this.pedido.id);
        this.pedido.status = 3;
        this.$eventbus.notificar("Pedido entregue com sucesso");
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao entregar o pedido");
      } finally {
        this.$refs.dialogoEntrega.fechar();
        this.entregando = false;
        this.pedido = {};
      }
    },
    async detalharPedidoCliente(pedido_cliente_id) {
      this.pedido_cliente.id = pedido_cliente_id;
      this.$refs.dialogoDetalhePedidoCliente.abrir();
    },
    fechardialogoDetalhePedidoCliente() {
      this.$refs.dialogoDetalhePedidoCliente.fechar();
    },
    abrirDialogoDesfazerEntrega(pedido) {
      this.pedido = pedido;
      this.$refs.dialogoDesfazerEntrega.abrir();
    },
    async desfazerEntregaPedido() {
      try {
        this.entregando = true;
        await ServicePedidos.desfazerEntrega(this.pedido.id);
        this.pedido.status = 1;
        this.$eventbus.notificar("Entrega desfeita com sucesso");
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao desfazer entrega do pedido");
      } finally {
        this.$refs.dialogoDesfazerEntrega.fechar();
        this.entregando = false;
        this.pedido = {};
      }
    },
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    setCliente(clienteLojaId) {
      const found = this.clientes.find((cli) => cli.id === clienteLojaId);
      this.filtro.cliente_id = found.cliente_id;
    },
  },
  computed: {
    ...mapGetters({
      pedidos: "pedidos",
      sincronizando: "sincronizando",
    }),
    quantidadePedidos() {
      let qtd_pedidos = 0;

      this.pedidos.forEach((pedido, index) => {
        if (pedido.status != 5) {
          qtd_pedidos++;
        }
      });

      return qtd_pedidos;
    },
    valorGeral() {
      let valor_total = 0;

      valor_total = this.pedidos.reduce((soma, pedido) => {
        if (pedido.status != 5) {
          return soma + pedido.valor_liquido;
        } else {
          return soma;
        }
      }, 0);

      return valor_total;
    },
    quantidadePedidosEntregues() {
      let qtd_pedidos_entregues = 0;

      this.pedidos.forEach((pedido, index) => {
        if (pedido.status == 3) {
          qtd_pedidos_entregues++;
        }
      });

      return qtd_pedidos_entregues;
    },
    valorEntregues() {
      let valor_total_entregues = 0;

      valor_total_entregues = this.pedidos.reduce((soma, pedido) => {
        if (pedido.status == 3) {
          return soma + pedido.valor_liquido;
        } else {
          return soma;
        }
      }, 0);

      return valor_total_entregues;
    },
    quantidadePedidosEnviados() {
      let qtd_pedidos_enviados = 0;

      this.pedidos.forEach((pedido, index) => {
        if (pedido.status == 4) {
          qtd_pedidos_enviados++;
        }
      });

      return qtd_pedidos_enviados;
    },
    valorEnviados() {
      let valor_total_enviados = 0;

      valor_total_enviados = this.pedidos.reduce((soma, pedido) => {
        if (pedido.status == 4) {
          return soma + pedido.valor_liquido;
        } else {
          return soma;
        }
      }, 0);

      return valor_total_enviados;
    },
    quantidadePedidosPendentes() {
      let qtd_pedidos_pendentes = 0;

      this.pedidos.forEach((pedido, index) => {
        if (pedido.status == 0 || pedido.status == 1) {
          qtd_pedidos_pendentes++;
        }
      });

      return qtd_pedidos_pendentes;
    },
    valorPendentes() {
      let valor_total_pendentes = 0;

      valor_total_pendentes = this.pedidos.reduce((soma, pedido) => {
        if (pedido.status == 0 || pedido.status == 1) {
          return soma + pedido.valor_liquido;
        } else {
          return soma;
        }
      }, 0);

      return valor_total_pendentes;
    },
  },
};
</script>

<style scoped>
.blinking {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.3;
  }
}
</style>
